// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EvidenceChaserItemDTO } from './evidence-chaser-item-dto';
import { EvidenceChaserRoundDTO } from './evidence-chaser-round-dto';

/**
 * 
 * @export
 * @interface EvidenceChaserDTO
 */
export interface EvidenceChaserDTO {
    /**
     * 
     * @type {string}
     * @memberof EvidenceChaserDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceChaserDTO
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceChaserDTO
     */
    type: EvidenceChaserDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceChaserDTO
     */
    status: EvidenceChaserDTOStatusEnum;
    /**
     * 
     * @type {Array<EvidenceChaserRoundDTO>}
     * @memberof EvidenceChaserDTO
     */
    rounds: Array<EvidenceChaserRoundDTO>;
    /**
     * 
     * @type {Array<EvidenceChaserItemDTO>}
     * @memberof EvidenceChaserDTO
     */
    items: Array<EvidenceChaserItemDTO>;
    /**
     * 
     * @type {string}
     * @memberof EvidenceChaserDTO
     */
    deadline?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceChaserDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceChaserDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum EvidenceChaserDTOTypeEnum {
    AUTOACCEPTED = 'AUTO_ACCEPTED',
    PREADR = 'PRE_ADR',
    POSTADR = 'POST_ADR'
}
/**
    * @export
    * @enum {string}
    */
export enum EvidenceChaserDTOStatusEnum {
    PENDING = 'PENDING',
    RESOLVED = 'RESOLVED',
    EXPIRED = 'EXPIRED'
}



